module.exports = {"apiKey":"AIzaSyC9a7OxvtaBxAbExTePxDzJ3jExi6wGVA0","authDomain":"advanced-sportclub-slate.firebaseapp.com","databaseURL":"https://advanced-sportclub-slate.firebaseio.com","projectId":"advanced-sportclub-slate","storageBucket":"advanced-sportclub-slate","messagingSenderId":"852202823951"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase.config.production.json
// module id = 444
// module chunks = 0